import React from "react";
import __ from "src/utils/Translations";

export const getEmployeeImportInstructions = (): React.ReactNode[] => [
  <>
    {__("Pierwszy wiersz pełni funkcję")} <strong>{__("nagłówka")}</strong>
    {", "}
    {__("a import danych rozpoczyna się od")}{" "}
    <strong>{__("drugiego wiersza")}</strong>. {__("Zawartość pierwszego")}{" "}
    <strong>{__("wiersza nie jest przetwarzana")}</strong>.
  </>,
  <>
    {__("Każdy pracownik musi mieć")}{" "}
    <strong>{__("unikalny identyfikator")}</strong>{" "}
    {__("w systemie kadrowo-płacowym.")}{" "}
    <strong>{__("Nie można go zmieniać")}</strong>{" "}
    {__("za pomocą tego importu.")}
  </>,
  <>
    {__("Tym importem")} <strong>{__("nie zaktualizujesz")}</strong>{" "}
    {__("takich danych jak")}
    <strong> {__("imię i nazwisko")}</strong>.
  </>,
  <>
    {__("Pole")}{" "}
    <strong>
      {__(
        "„Identyfikator pracownika w systemie kadrowo-płacowym” jest obowiązkowe"
      )}
    </strong>
    {" - "}
    {__("bez niego")} <strong>{__("import nie będzie możliwy")}</strong>.
  </>,
  <>
    {__("Import służy")}{" "}
    <strong>
      {__(
        "tylko do aktualizacji danych pracowników. Nie tworzy nowych kont użytkowników"
      )}
    </strong>
    .
  </>,
  <>
    {__("Każdy wiersz w pliku powinien zawierać dokładnie")}{" "}
    <strong>{__("21 kolumn")}</strong>
    {". "}
    {__("Wypełniasz tylko te pola, które chcesz")}{" "}
    <strong>{__("zaktualizować")}</strong>
    {" - "}
    {__("pozostałe możesz zostawić puste")}.
  </>,
  <>
    {__("Jeśli chcesz wyczyścić dane w danym polu, wpisz")}{" "}
    <strong>{__("„NULL”")}</strong>
    {". "}
    {__("To pozwoli")} <strong>{__("usunąć istniejącą wartość")}</strong>.
  </>,
  <>
    {__("Możesz skorzystać z gotowego")}{" "}
    <strong>{__("szablonu z nazwami kolumn")}</strong>{" "}
    {__("lub wyeksportować plik z")}{" "}
    <strong>{__("aktualnymi danymi pracowników")}</strong>
    {", "}
    {__("jeśli chcesz edytować je zbiorczo.")}
  </>,
  <>
    {__("Jeśli numer kadrowo-płacowy występuje w pliku więcej niż jeden raz")}
    {", "}
    {__("w systemie zostaną zachowane dane odpowiadające")}{" "}
    <strong>{__("ostatniemu wystąpieniu")}</strong> {__("tego numeru.")}
  </>,
  <>
    {__("Oczekiwany format plików to")}{" "}
    <strong>{__("CSV UTF-8 rozdzielany średnikami")}</strong>
  </>,
];

export const getEmployeeUpdateFields = (): string[] => [
  __("Numer MPK"),
  __("Adres email służbowy"),
  __("Telefon służbowy"),
  __("Telefon służbowy 2"),
  __("Stanowisko"),
  __("Obszar"),
  __("Wyświetlany dodatkowy obszar"),
  __("Przełożony"),
  __("Lokalizacja"),
  __("Data rozpoczęcia zatrudnienia"),
  __("Data zakończenia zatrudnienia"),
  __("Rodzaj umowy"),
  __("Forma zatrudnienia"),
  __("Wymiar etatu"),
  __("Godzinowy wymiar pracy"),
];
